/**
 * @generated SignedSource<<ca19a106c5094ae62c240242f3120e15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type usePortalEligibleApproversQuery$variables = {
  projectId: string;
};
export type usePortalEligibleApproversQuery$data = {
  readonly viewer: {
    readonly project: {
      readonly portalEligibleApprovers: ReadonlyArray<{
        readonly portalUserId: string | null;
        readonly email: string | null;
        readonly roleLabel: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type usePortalEligibleApproversQuery = {
  variables: usePortalEligibleApproversQuery$variables;
  response: usePortalEligibleApproversQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "projectId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PortalEligibleApprover",
  "kind": "LinkedField",
  "name": "portalEligibleApprovers",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalUserId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roleLabel",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePortalEligibleApproversQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePortalEligibleApproversQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c6558c174008fe363742dbd532835b3e",
    "id": null,
    "metadata": {},
    "name": "usePortalEligibleApproversQuery",
    "operationKind": "query",
    "text": "query usePortalEligibleApproversQuery(\n  $projectId: ID!\n) {\n  viewer {\n    project(internalId: $projectId) {\n      portalEligibleApprovers {\n        portalUserId\n        email\n        roleLabel\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce3e41ac559e2bfc37ed4fa152c0f7f2";

export default node;
